import { Nav, NavLink } from 'reactstrap'
import { Href, QuickOption } from '../../../Utils/Constants'
import NavLinks from './NavLinks'
import { Image } from '../../../AbstractElements'
import { dynamicImage } from '../../../Utils'
import { NavCustomizerType } from '../../../Types/ThemeCustomizerTypes'

const NavCustomizer = ({ callbackNav, selected }: NavCustomizerType) => {
  return (
    <Nav className="flex-column nac-pills">
      <NavLink
        className={`${selected === "sidebar-type" ? "active" : ""}` }
        onClick={() => callbackNav("sidebar-type", true)}
        href={Href}
      >
        <div className="settings">
          <Image src={dynamicImage(`customizer/color.png`)} alt="icons" />
        </div>
        <span>{QuickOption}</span>
      </NavLink>
      <NavLinks />
    </Nav>
  )
}

export default NavCustomizer